module.exports = __webpack_public_path__ + "img/glogo242.334534cd.png";